export default __webpack_public_path__ + "static/media/238.915caa84.png";